export const DownloadIcon = () => (
  <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.39209" y="0.571442" width="24.1283" height="19.9032" fill="white" />
    <path
      d="M10.135 3.05936V8.49789H5.65047L12.3773 13.9364L19.1041 8.49789H14.6196V3.05936H10.135ZM3.4082 15.7493V17.5621H21.3464V15.7493H3.4082Z"
      fill="#F06D24"
    />
  </svg>
);
